import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const [roomId, setRoomId] = useState('');
  const navigate = useNavigate();

  const generateRoomId = () => {
    return Math.random().toString(36).substring(2, 9);
  };

  const handleCreateRoom = () => {
    const newRoomId = generateRoomId();
    navigate(`/editor/${newRoomId}`);
  };

  const handleJoinRoom = (e) => {
    e.preventDefault();
    if (roomId.trim()) {
      navigate(`/editor/${roomId}`);
    }
  };

  return (
    <div className="home-container">
      <div className="home-card">
        <h2>Start Coding Together</h2>
        
        <div className="action-section">
          <button 
            className="btn btn-primary btn-large"
            onClick={handleCreateRoom}
          >
            Create New Room
          </button>
          <p className="divider">OR</p>
        </div>

        <form onSubmit={handleJoinRoom} className="join-form">
          <input
            type="text"
            placeholder="Enter Room ID"
            value={roomId}
            onChange={(e) => setRoomId(e.target.value)}
            className="input-field"
          />
          <button 
            type="submit" 
            className="btn btn-secondary"
            disabled={!roomId.trim()}
          >
            Join Room
          </button>
        </form>
      </div>
    </div>
  );
}

export default Home;